import framePopper from '@gustavnikolaj/frame-popper';

type AugmentedError = Error & { framesToPop: number };

const throwError = (message: string) => {
  const error = new Error(`[Core] ${message}`) as AugmentedError;

  // Firefox
  if (error.stack && !error.stack.includes(error.message)) {
    error.stack = error.stack.split('\n').slice(1).join('\n');
  // Chrome & Webkit
  } else if (error.stack) {
    error.framesToPop = 1;
    framePopper(error);
  }
  // IE does not support stack

  throw error;
};

export default throwError;
